import React, { useState, useEffect } from 'react'
import { useForm, Controller } from 'react-hook-form'
import { Panel, Form, Message, RadioGroup, Radio } from 'rsuite'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import ProposalReviseForm from '../../components/forms/proposalReviseForm/ProposalReviseForm'
import { saveProposalRevise, saveProposalReviseNew } from '../../redux/actions/proposalRevise'
import pathname from '../../constants/pathname'
import { useParams, useHistory } from 'react-router-dom'
import { startLoading, doneLoading } from '../../utils/loading'
import InputForm from '../../components/forms/input/InputForm'
import ConfirmWidget from '../confirm/ConfirmWidget'
import { isEmpty } from 'lodash-es'

export default function ProposalSendBackNew(props) {
  const { register, handleSubmit, errors, control, setValue, setError, clearErrors } = useForm()
  const [formSchema, setFormSchema] = useState(props.schema)
  const [isLoading, setIsLoading] = useState()
  const [isError, setIsError] = useState()
  const [isShowConfimModal, setIsShowConfimModal] = useState(false)
  const [request, setRequest] = useState()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  // const projectId = '9BE3B891-FD65-416B-8459-7AD624B5D3F2'
  let history = useHistory()

  useEffect(() => {
    if (props.schema.optionValue) {
      setValue('optionValue', props.schema.optionValue)
    } else {
      setValue('optionValue', '0')
    }
  }, [props.schema])

  const handleCallService = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      const _schema = await saveProposalReviseNew(projectId, request)
      setIsLoading(false)
      doneLoading()
      setIsShowConfimModal(false)
      const _projectVersionId =
        _schema.projectVersionId || _schema.model?.projectVersionId || projectId

      sessionStorage.setItem('projectId', _projectVersionId)
      sessionStorage.setItem('param', '')

      return history.push(`${pathname.proposal.overview.overviewCoworker}`)
    } catch (e) {
      console.log('e', e)
      if (e?.response?.data?.errors) {
        setIsError(e?.response?.data?.errors.message)
      } else {
        setIsError(
          'เกิดข้อผิดพลาดในการส่งกลับผู้ขอรับทุน กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ'
        )
      }
    }
    setIsShowConfimModal(false)
    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    console.log('ProposalSendBack onSubmit', data)
    setIsError()

    let notSelected = true

    // set projectFeedbackId = null (ถ้ามีค่า จะถูกหลังบ้านลบทิ้ง และภาคีจะไม่เห็น)
    for (const item of data.requestBody) {
      if (item.subItems) {
        for (const subItem of item.subItems) {
          subItem.projectFeedbackId = null

          //check if not select throw error
          if (subItem.selected) {
            notSelected = false
          }

          //เอา valid value ออก เพิ่มกรณีเลือก แต่ไม่ได้กรอกมา replace ""
          if (subItem.selected && !subItem.value) {
            console.log('selected but value is null')
            subItem.value = ''
          }

          if (subItem.subItems) {
            for (const subSubItem of subItem.subItems) {
              subSubItem.projectFeedbackId = null

              //check if not select throw error
              if (subSubItem.selected) {
                notSelected = false
              }

              //เอา valid value ออก เพิ่มกรณีเลือก แต่ไม่ได้กรอกมา replace ""
              if (subSubItem.selected && !subSubItem.value) {
                console.log('selected but value is null')
                subSubItem.value = ''
              }
            }
          }
        }
      }
    }

    //check if not select throw error
    if (notSelected) {
      setIsError('กรุณาเลือกหัวข้อที่ต้องการส่งกลับแก้ไข')
      return
    }

    const request = {
      revises: data.requestBody,
      remark: data.remark || '',
      optionValue: data.optionValue,
    }

    // console.log('request', JSON.stringify(request))
    //handleCallService(request)
    setRequest(request)
    setIsShowConfimModal(true)
  }

  return (
    <>
      <Form fluid>
        <Panel shaded header="" bordered collapsible defaultExpanded>
          <ProposalReviseForm
            schema={formSchema.revises || []}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            setValue={setValue}
            clearErrors={clearErrors}
            isSendBackNew={true}
          />

          {/* <InputForm
            //disabled={formSchema.note.disabled}
            schema={formSchema.remark}
            rows={4}
            componentClass="textarea"
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            setValue={setValue}
            clearErrors={clearErrors}
          /> */}

          {!props.disabledForm && (
          <>
          <div>
            <Controller
              key={'optionValue'}
              name={'optionValue'}
              control={control}
              defaultValue={'0'}
              render={(props) => {
                return (
                  <RadioGroup
                    onChange={(value) => {
                      props.onChange(value)
                      //setCheckApprove(value)
                    }}
                    value={props.value}
                    //checked={checkApprove}
                  >
                    <Radio value={'0'}>{'ภาคีเป็นผู้ปรับแก้'}</Radio>
                    <Radio value={'1'}>{'นักวิชาการเป็นผู้ปรับแก้'}</Radio>
                  </RadioGroup>
                )
              }}
            />
          </div>

          <hr />

          {isError && (
            <div style={{ marginTop: 10, marginBottom: 10 }}>
              <Message showIcon type="error" description={isError} />
            </div>
          )}

          <SaveButton disabled={isLoading} onClick={handleSubmit(onSubmit)}>
            {formSchema.buttonText || 'ส่งกลับผู้ขอรับทุน'}
          </SaveButton>
          </>)}
        </Panel>
        <br />
      </Form>

      <ConfirmWidget
        title={`ยืนยันการส่งกลับผู้ขอรับทุน`}
        show={isShowConfimModal}
        detail={`กรุณายืนยันการส่งกลับผู้ขอรับทุน`}
        onCancle={() => setIsShowConfimModal(false)}
        onConfirm={() => handleCallService(request)}
      />
    </>
  )
}
